const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/dashboards/generated/$dashboardId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import i18n from '@/common/translations/i18n';
import { ensureNamespaceLoaded } from '@/common/translations/i18nloader';
const paramsSchema = z.object({
  dashboardId: z.string().refine(value => value === 'new' || /^\d+$/.test(value))
});
export const Route = createFileRoute('/(app)/org/$org/dashboards/generated/$dashboardId/')({
  params: paramsSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ctx => {
    await ensureNamespaceLoaded('aiDashboards');
    if (!ctx.context.flags.aiGeneratedDashboardsEnabled) {
      throw redirect({
        to: '/org/$org/dashboards',
        params: {
          org: ctx.params.org
        }
      });
    }
  },
  staticData: {
    topNav: {
      title: i18n.t($ => $.dashboard.orgPage.title)
    }
  }
});